import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson1DefaultStartCode = `// TODO: Get the bar_for_fuzz and default_to_baz tests passing!
${doNotModifyCodeAbove}`;

export const lesson1DefaultMiddleCode = `fn foo_if_fizz(fizzish: felt252) -> felt252 {
    // Complete this function using if, else if and/or else blocks.
    // If fizzish is,
    // 'fizz', return 'foo'
    // 'fuzz', return 'bar'
    // anything else, return 'baz'
    if fizzish == 'fizz' {
        'foo'
    } else {
        1_u32
    }
}`;

export const lesson1DefaultEndCode = `${doNotModifyCodeBelow}
mod tests {
    use super::foo_if_fizz;

    #[test]
    fn foo_for_fizz() {
        assert(foo_if_fizz('fizz') == 'foo', 'fizz returns foo');
    }

    #[test]
    fn bar_for_fuzz() {
        assert(foo_if_fizz('fuzz') == 'bar', 'fuzz returns bar');
    }

    #[test]
    fn default_to_baz() {
        assert(foo_if_fizz('literally anything') == 'baz', 'anything else returns baz');
    }
}`;
